<template>
  <div class="page">
    <header class="page__header">
      <page-container>
        <div class="page__header__inner">
          <div class="header-item header-item--left">
            <slot name="headerLeft">
              <PageLogo inverted-colors />
            </slot>
          </div>

          <div class="header-item header-item--center">
            <slot name="headerCenter" />
          </div>

          <div class="header-item header-item--right">
            <slot name="headerRight" />
          </div>
        </div>
      </page-container>
    </header>
    <!-- Use the dynamic class to customize its CSS -->
    <main class="page__main" :class="[`page__main--${$route.name}`]">
      <page-container>
        <slot />
      </page-container>
    </main>
    <footer v-if="hasFooter" class="page__footer">
      <page-container>
        <slot name="footer" />
      </page-container>
    </footer>
  </div>
</template>

<script>
import PageContainer from '@/layout/components/PageContainer.vue';
import PageLogo from '@/components/PageLogo.vue';
import { DEALS as DEALS_ROUTES } from '@/router/wizard/ROUTE_NAMES';

export default {
  name: 'SlideBase',
  components: {
    PageContainer,
    PageLogo,
  },
  data() {
    return {
      DEALS_ROUTES,
    };
  },
  computed: {
    hasFooter() {
      return Boolean(this.$slots.footer);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.page {
  display: flex;
  flex-direction: column;
  align-items: stretch;

  &__header {
    background-color: white;
    padding-top: $sp-s;
    padding-bottom: $sp-s;
    position: sticky;
    top: 0;
    z-index: 30;
    box-shadow: 0 5px 5px 2px white;
    margin-bottom: $sp-s;

    @include for('tablet') {
      padding-top: calc(#{$sp-l} + 20px);
      padding-bottom: $sp-l;
    }

    &__inner {
      display: flex;
      justify-content: space-between;
    }
  }

  .header-item {
    &--left {
      flex: 1;
      justify-content: flex-end;
      max-width: 50%;
    }

    &--right {
      display: flex;
      justify-content: flex-end;
      flex: 1;
      max-width: 50%;
    }
  }

  &__main {
    flex-grow: 1;
  }
}
</style>
